import { Component } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { browserCheck } from '@ta-interaktiv/browsercheck';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var stagingServerMarker = /-igr/;
var paywallScriptsVersion = "cre-1.0";
var TamediaPaywall = (function (_super) {
    __extends(TamediaPaywall, _super);
    function TamediaPaywall(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isMounted: false
        };
        _this.paywallScripts = [];
        _this.scriptLoadingState = {};
        var isInApp = new URL(window.location.href).searchParams.has('appwebview');
        if (isInApp) {
            return _this;
        }
        var isOnStagingServer = stagingServerMarker.test(window.location.hostname);
        var subdomainSuffix = isOnStagingServer ? '-igr' : '';
        var hostname = parseHostname();
        if (_this.props.paywallStatus > 0) {
            _this.paywallScripts.push([
                'templateClient',
                "https://track" + subdomainSuffix + "." + hostname.publicationDomain + "/" + paywallScriptsVersion + "/static/tracking/1.0/templateclient.js"
            ], [
                'tracking',
                "https://track" + subdomainSuffix + "." + hostname.publicationDomain + "/" + paywallScriptsVersion + "/tracking/tracking.js"
            ]);
            _this.scriptLoadingState['templateClient'] = false;
            _this.scriptLoadingState['tracking'] = false;
        }
        if (_this.props.paywallStatus > 1) {
            _this.paywallScripts.push([
                'templateSets',
                "https://track" + subdomainSuffix + "." + hostname.publicationDomain + "/" + paywallScriptsVersion + "/cockpit/platform/tamedia/shop/" + hostname.publicationName + "/api/templatesets.js"
            ]);
            _this.scriptLoadingState['templateSets'] = false;
        }
        return _this;
    }
    TamediaPaywall.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.isEnabled) {
            this.paywallScripts.forEach(function (scriptDefinition) {
                var script = window.document.createElement('script');
                script.src = scriptDefinition[1];
                script.async = true;
                script.onload = function () {
                    _this.onLoadHandler(scriptDefinition[0]);
                };
                window.document.body.appendChild(script);
            });
        }
    };
    TamediaPaywall.prototype.render = function () {
        return null;
    };
    TamediaPaywall.prototype.onLoadHandler = function (scriptMarker) {
        this.scriptLoadingState[scriptMarker] = true;
        if (Object.values(this.scriptLoadingState).every(function (val) { return val; })) {
            this.setupPaywall();
        }
    };
    TamediaPaywall.prototype.setupPaywall = function () {
        window.cre_templateclient &&
            window.cre_templateclient.setup({
                container_id: this.props.paywallContainerId
            });
        var origin = 'web';
        if (window.matchMedia('(max-width: 799px)').matches) {
            origin = 'mobile';
        }
        if (browserCheck.isNativeApp) {
            origin = 'app';
        }
        var config = {
            cms_id: this.props.paywallConfiguration.cms_id.toString(),
            content_id: window.location.pathname,
            doc_type: this.props.paywallConfiguration.doc_type,
            channel: this.props.paywallConfiguration.main_channel,
            sub_channel: this.props.paywallConfiguration.sub_channel,
            heading: window.document.title,
            service_id: parseHostname().publicationName,
            origin: origin
        };
        this.setTrackingData(config, 'page_view');
        this.setTrackingData(config, 'page_complete');
    };
    TamediaPaywall.prototype.setTrackingData = function (config, action) {
        if (window.cre_client == null) {
            return;
        }
        window.cre_client["set_" + action]();
        Object.entries(config).forEach(function (keyValuePair) {
            window.cre_client["set_" + keyValuePair[0]](keyValuePair[1]);
        });
        window.cre_client.request();
    };
    TamediaPaywall.defaultProps = {
        paywallContainerId: 'paywall_container',
        paywallStatus: 0
    };
    return TamediaPaywall;
}(Component));

export default TamediaPaywall;
export { TamediaPaywall as Paywall };
//# sourceMappingURL=index.js.map
